import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=406a5e52&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"
import style0 from "./Write.vue?vue&type=style&index=0&id=406a5e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a5e52",
  null
  
)

export default component.exports